/**
 * 将接口返回的日期时间转为页面展示：美国区域设置的 12 小时制（AM/PM）。
 * 支持本地样式 yyyy-MM-dd HH:mm:ss、ISO-8601（T 分隔、毫秒、Z）等。
 */

const US_DT = new Intl.DateTimeFormat('en-US', {
  month: 'numeric',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  second: '2-digit',
  hour12: true
})

function parseBackendDateTime(value) {
  if (value == null || value === '') return null
  const raw = String(value).trim()
  if (!raw) return null

  if (/Z$/i.test(raw)) {
    const d = new Date(raw.replace(/\.\d{3,}/, ''))
    return Number.isNaN(d.getTime()) ? null : d
  }

  let s = raw.replace('T', ' ').replace(/\.\d{3,}/, '').trim()

  const dateOnly = s.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (dateOnly) {
    return new Date(+dateOnly[1], +dateOnly[2] - 1, +dateOnly[3])
  }

  const local = s.match(/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/)
  if (local) {
    return new Date(+local[1], +local[2] - 1, +local[3], +local[4], +local[5], +local[6])
  }

  const d = new Date(s)
  return Number.isNaN(d.getTime()) ? null : d
}

export function formatDisplayDateTime(value) {
  const date = parseBackendDateTime(value)
  if (!date) return ''
  return US_DT.format(date)
}
